import { useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import { useDiscussionRepository } from '../../../../../../services/adaptors/discussionRepositoryAdapter'
import { Discussion } from '../../../../../../domain/entity/DiscussionEntity'
import {
  addGlobalMessage,
  MessageLevel,
} from '../../../../../../store/messages'

interface UseDiscussionProps {
  versionPageUuid?: string
}

export const useDiscussion = ({ versionPageUuid }: UseDiscussionProps) => {
  const [discussion, setDiscussion] = useState<Discussion | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const { getDiscussion } = useDiscussionRepository()
  const dispatch = useDispatch()
  const intl = useIntl()

  const fetchDiscussion = useCallback(async () => {
    if (!versionPageUuid) {
      return
    }

    try {
      setIsLoading(true)
      const result = await getDiscussion(versionPageUuid)
      setDiscussion(result)
    } catch (error) {
      dispatch(
        addGlobalMessage({
          type: MessageLevel.ERROR,
          title: intl.formatMessage({ id: 'discussion.error.fetch' }),
        })
      )
      setDiscussion(null)
    } finally {
      setIsLoading(false)
    }
  }, [versionPageUuid, getDiscussion, dispatch, intl])

  const refreshDiscussion = useCallback(() => {
    fetchDiscussion()
  }, [fetchDiscussion])

  useEffect(() => {
    fetchDiscussion()
  }, [fetchDiscussion])

  return {
    discussion,
    isLoading,
    refreshDiscussion,
  }
}
